<template>
  <g clip-path="url(#clip0_942_24399)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.17839 3.00391C7.5867 3.00391 7.00138 3.2578 6.5566 3.7396C6.10935 4.22409 5.8457 4.89713 5.8457 5.61404V7.50391H10.5111V5.61404C10.5111 4.89713 10.2474 4.22409 9.80018 3.7396C9.35541 3.2578 8.77008 3.00391 8.17839 3.00391ZM3.8457 5.61404V7.55067C2.85652 7.76461 2.17676 8.68281 2.17676 9.6854V13.8207C2.17676 14.9665 3.06469 16.0021 4.28765 16.0021H12.0639C13.2869 16.0021 14.1748 14.9665 14.1748 13.8207V9.6854C14.1748 8.68457 13.4974 7.76783 12.5111 7.5518V5.61404C12.5111 4.41602 12.0725 3.25256 11.2697 2.38298C10.4645 1.51072 9.35447 1.00391 8.17839 1.00391C7.00232 1.00391 5.89228 1.51072 5.08705 2.38298C4.2843 3.25256 3.8457 4.41602 3.8457 5.61404Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_942_24399">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</template>
